import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import ShipmentMasterReducer from "./reducer";
const ShipmentMaster = combineReducers({
  ShipmentMaster: ShipmentMasterReducer,
  form: formReducer,
});

export default ShipmentMaster;
